export default function initialContentValue(objectWithContent, key, defaultIfMissing) {
	if (
		!objectWithContent ||
		!objectWithContent.content ||
		objectWithContent.content[key] === undefined
	) {
		return defaultIfMissing;
	}
	return objectWithContent.content[key];
}
